import type {
  ButtonProps as LegacyButtonProps,
  ButtonVariant as LegacyButtonVariant,
} from '@tw/tw-component-library';
import type {
  ButtonProps as WtButtonProps,
  ButtonVariant as WtButtonVariant,
} from '@tw/tw-component-library/common-wt';

// ============= Constants =============

/**
 * Maps the Litium Button variants to the closest Winston Taylor equivalent.
 * The WT Button exposes a smaller variant set, so several Litium variants
 * collapse onto the same WT variant.
 */
const VARIANT_MAP: Record<LegacyButtonVariant, WtButtonVariant> = {
  primary: 'primary',
  secondary: 'secondary',
  block: 'primary',
  blockAlt: 'secondary',
  outline: 'secondary',
  outlineHover: 'secondary',
  outlineHoverAlt: 'secondary',
  ghost: 'ghost',
  ghostHover: 'ghost',
};

// ============= Utils =============

/**
 * Converts Litium Button props into Winston Taylor Button props. Only the
 * `variant` differs between the two APIs; every other prop (size, fullWidth,
 * isLoading, icons, native button attributes) passes straight through.
 */
export const mapButtonProps = (props: LegacyButtonProps): WtButtonProps => {
  const { variant, ...rest } = props;
  return {
    ...rest,
    variant: variant ? VARIANT_MAP[variant] : undefined,
  };
};
